import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Heading, Title } from '@siftscience/focus-components/text'
import Actions, { ActionProps } from './Actions'

const useStyles = makeStyles(() => ({
  container: {
    height: '84px',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'fixed',
    width: '100%',
    backgroundColor: 'white',
    zIndex: 2
  },
  title: {
    padding: '0',
    margin: '0'
  }
}))

const Header = (props: ActionProps) => {
  const classes = useStyles()
  return (
    <div className={`shadow-s ${classes.container}`}>
      <div>
        <Heading className={classes.title} size={4}>
          Image Library
        </Heading>
        <Title color="secondary" size="xsmall">
          {props.totalImages} images
        </Title>
      </div>
      <Actions {...props} />
    </div>
  )
}

export default Header
